export function getGameIdFromURL() {
	let url = new URL(window.location.href);
	let id = new URLSearchParams(url.searchParams).get("gameId");
	return id;
}

export const simpsons = [

];